<template>
<div>
  <div>
    <div>
      <small class="subtitle" style="margin-left: 10px;" v-if="campaignName">{{ campaignName }}</small>
      <select class="d-none">
          <option v-for="option in getValue" v-bind:key="option.id" :value="option.id" selected>{{ option.value }}</option>
      </select>
      <Multiselect
        v-model="tags"
        :options="options"
        :selected="getValue"
        :value="tags"
        label="label"
        track-by="value"
        multiple
        placeholder="Escolha uma tag"
        @select="verifyTag"
        @remove="removeTag"
      ></Multiselect>
    </div>
    <b-modal
      id="modal-add-scheduledDate"
      ref="modal-add-scheduledDate"
      title="Informe uma data"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Data"
          label-for="scheduledDate-input"
        >
        <v-date-picker
          v-model="scheduledDate"
          :input-props='{
            class: "form-control",
            placeholder: "Selecione uma data",
            readonly: true
          }'
        >
        </v-date-picker>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</div>
</template>

<script>
import Multiselect from './Multiselect'

export default {
  components: {
    Multiselect
  },
  data () {
    return {
      tags: [],
      options: [{ value: '', label: '', variant: '' }],
      tag: null,
      scheduledDate: null,
      campaignName: null
    }
  },
  computed: {
    getValue () {
      return this.tags
    }
  },
  watch: {
    value (newValue, oldValue) {
      // This will force the v-model of the parent to update
      this.$emit('input', this.tags)
    }
  },
  mounted () {
    this.listTags()
    this.getTags()
  },
  methods: {
    verifyTag (tag) {
      if (tag.requestDate) {
        this.saveTag(tag)
        setTimeout(() => {
          this.tag = tag
        }, 1000)
        this.$refs['modal-add-scheduledDate'].show()
      } else {
        this.saveTag(tag)
      }
    },
    addTag (t) {
      let newoption = { value: t, label: t }
      this.options.push(newoption)
      this.dataArrayTaggable.push(newoption)
    },
    listTags () {
      this.$http.get('api/tags')
        .then(function (res) {
          let list = res.data.list

          list.map(tag => {
            this.options.push({
              value: tag.id, label: tag.name, variant: tag.variant, requestDate: tag.requestDate
            })
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    getTags () {
      this.$http.get(`api/transactions/${this.$route.params.txid}/tags`)
        .then(function (res) {
          let list = res.data.list
          this.campaignName = res.data.campaignName

          this.tags = []

          list.map(tag => {
            this.tags.push({
              value: tag.id,
              label: tag.name,
              variant: tag.variant,
              date: tag.date,
              creatorName: tag.creatorName,
              scheduledDate: tag.scheduledDate,
              campaignName: tag.campaignName
            })
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    resetModal () {
      this.scheduledDate = ''
    },
    handleOk (evt) {
      this.handleSubmit()
    },
    handleSubmit () {
      this.addScheduledDate(this.tag)

      this.$nextTick(() => {
        this.$bvModal.hide('modal-add-scheduledDate')
      })
    },
    addScheduledDate (tag) {
      this.$http.patch(`api/transactions/${this.$route.params.txid}/tags`, {
        tagId: tag.value,
        scheduledDate: this.formatStringDate(this.scheduledDate)
      })
        .then(function (res) {
          console.log('recorded')
          this.$bvToast.toast('Data adicionada com sucesso', {
            autoHideDelay: 5000,
            variant: 'success'
          })
          this.tags = []
          this.getTags()
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(res, {
            title: 'Erro ao adicionar data',
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })
    },
    saveTag (tag) {
      this.$http.post(`api/transactions/${this.$route.params.txid}/tags`, {
        tagId: tag.value
      })
        .then(function (res) {
          console.log('recorded')
          this.$bvToast.toast('Tag adicionada com sucesso', {
            autoHideDelay: 5000,
            variant: 'success'
          })
          this.getTags()
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(res, {
            title: 'Erro ao adicionar tag',
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })
    },
    removeTag (tag) {
      console.log('Apagando ')
      console.log(tag)
      this.$http.delete(`api/transactions/${this.$route.params.txid}/tags`, {body: {
        tagId: tag.value
      }})
        .then(function (res) {
          console.log('deleted')
          this.$bvToast.toast('Tag removida com sucesso', {
            autoHideDelay: 5000,
            variant: 'success'
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(res, {
            title: 'Erro ao remover tag',
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })
    },
    formatStringDate (str) {
      let date = new Date(str)
      let mnth = ('0' + (date.getMonth() + 1)).slice(-2)
      let day = ('0' + date.getDate()).slice(-2)
      return [date.getFullYear(), mnth, day].join('-')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/partial/tags/Tags.vue